export default "https://cdn.questicon.mathletics.com/assets/audio/selfAssesmentEmojis_2-adffd1bdf145d6b8020ccd277cae15eb.mp3";